import { type ContraImage } from '#app/components/Avatars/Avatar/types.js';
import { AvatarWithDetails } from '#app/components/Avatars/AvatarWithDetails/AvatarWithDetails.js';
import { styled } from 'styled-components';

export type AuthorBlockProps = {
  readonly avatarImage: ContraImage | null;
  readonly displayUsername: string;
  readonly firstName: null | string;
  readonly id: string;
  readonly lastName: null | string;
  readonly showAuthorTitle?: boolean;
  readonly title: null | string;
};

const BlockContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  align-items: center;
`;

export const AuthorBlock = ({
  avatarImage,
  displayUsername,
  firstName,
  lastName,
  showAuthorTitle = false,
  title,
}: AuthorBlockProps) => {
  return (
    <BlockContainer>
      <AvatarWithDetails
        avatarImage={avatarImage}
        displayUsername={displayUsername}
        headline={showAuthorTitle ? 'AUTHOR' : undefined}
        size="lg"
        subtitle={title}
        userName={`${firstName} ${lastName}`}
      />
    </BlockContainer>
  );
};
